import React from "react";
import { useTranslation } from "react-i18next";
import PageWrapper from "../pageWrapper";

//CSS
import "./trafficPage.css";

//Components
import TrafficView from "../../Components/Traffic Components/trafficView";

//Functions and hooks

export default function TrafficPage() {
  const { t } = useTranslation();

  const tutorialSteps = [
    {
      target: null,
      title: t("Your traffic", { ns: "tutorial" }),
      message: t(
        "This is your Traffic page - every note that moves stock in or out of a warehouse (received goods, deliveries, and sales) lives here.",
        { ns: "tutorial" }
      ),
    },
    {
      target: ".btn-container.start .btn-positive",
      title: t("Create a note", { ns: "tutorial" }),
      message: t(
        "Start a new traffic note - a received goods note, a delivery, or a sale - and pick which warehouse and items it affects.",
        { ns: "tutorial" }
      ),
    },
    {
      target: ".search-bar-container",
      title: t("Search", { ns: "tutorial" }),
      message: t("Search for a note by its ID.", { ns: "tutorial" }),
    },
    {
      target: ".sortAndFilterBar",
      title: t("Sort and filter", { ns: "tutorial" }),
      message: t(
        "Sort the list by ID, type, warehouse, client, price, or date, and use Filters to narrow notes down by any of those properties.",
        { ns: "tutorial" }
      ),
    },
    {
      target: ".item-card-container .Card:first-child",
      title: t("Note rows", { ns: "tutorial" }),
      message: t(
        "Each row is one note, with its type, warehouse, client, price, and date. Click View to see its full details.",
        { ns: "tutorial" }
      ),
    },
    {
      target: ".export-container",
      title: t("Export", { ns: "tutorial" }),
      message: t(
        "Export the current traffic list to Excel or CSV - this respects whatever search, filter, and sort you've currently applied.",
        { ns: "tutorial" }
      ),
    },
  ];

  return (
    <PageWrapper tutorialId="traffic" tutorialSteps={tutorialSteps}>
      <div className="page-content ">
        <div className="view-page-container ">
          <TrafficView
            bShowAll={true}
            propertiesToShow={{
              ID: { Show: true, Width: 2 },
              Type: { Show: true, Width: 2 },
              Warehouse: { Show: true, Width: 2 },
              Client: { Show: true, Width: 2 },
              Price: { Show: true, Width: 1 },
              Discount: { Show: false, Width: 1 },
              DateTime: { Show: true, Width: 2 },
            }}
          />
        </div>
      </div>
    </PageWrapper>
  );
}
